import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { SearchBoxHintConfig } from 'src/app/modules/shared/models/section-config.model';

@Component({
    selector: 'search-box-hint-configuration',
    templateUrl: 'search-box-hint-configuration.component.html',
    styleUrls: ['search-box-hint-configuration.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchBoxHintConfigurationComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() searchBoxHintConfig: SearchBoxHintConfig;

  expanded: boolean = false;
  form: FormGroup;  

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  private addControls(): void {
    this.form = this.fb.group({
      show: this.fb.control(this.searchBoxHintConfig?.show),
      minCountOfPagesToShowHint: this.fb.control(this.searchBoxHintConfig?.minCountOfPagesToShowHint)
    });
    this.parentFormGroup.addControl('searchBoxHintConfig', this.form);
  }
}